var map = {
	"./de.json": [
		"./src/i18n/de.json",
		"src_i18n_de_json"
	],
	"./en.json": [
		"./src/i18n/en.json",
		"src_i18n_en_json"
	],
	"./es.json": [
		"./src/i18n/es.json",
		"src_i18n_es_json"
	],
	"./gl.json": [
		"./src/i18n/gl.json",
		"src_i18n_gl_json"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "./src/i18n lazy recursive ^\\.\\/.*\\.json$ referencedExports: default";
module.exports = webpackAsyncContext;